import { useEffect, useState } from "react";
import { useHistory } from "react-router";
// Components
import BannerOne from "../../../components/BannerOne";
// Constants
import {
  TITLE,
  BUTTON_NAME,
  BUTTON_LINK,
  ALL_NEWS_LIST,
  ALL_EVENTS_LIST,
  ALL_BANNERS,
} from "./WelcomeConstants";

// Images
import homepageBanner from "../../../assets/img/partnerPortal/homepage.png";
import deal_banner from "../../../assets/img/partnerPortal/welcomePage/dealBanner.png";
import demo_banner from "../../../assets/img/partnerPortal/welcomePage/demoImg.png";
import salesIcon from "../../../assets/img/partnerPortal/EnablementSales/sales_icon.svg";
import salesSpecialistIcon from "../../../assets/img/partnerPortal/EnablementSales/sales_specialist_icon.svg";
import salesEngineerIcon from "../../../assets/img/partnerPortal/EnablementSales/sales_engineer_icon.svg";
import deliveryConsultantIcon from "../../../assets/img/partnerPortal/EnablementSales/delivery_consultant_icon.svg";

// Scss
import "../../../assets/css/partnerProgram.scss";
import "../../../assets/css/partnerPortal/welcome.scss";

import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import Image from "react-bootstrap/Image";
import NewsSection from "../../../components/NewsSection";
import Title from "../../../components/Title";
import CardLink from "../../../components/CardLink";
import ButtonOne from "../../../components/ButtonOne";
import { Carousel } from "react-bootstrap";

function WelcomeOnlyPdr() {
  let history = useHistory();
  const [buttonNameNews, setButtonNameNews] = useState("Show more");
  const [buttonNameEvents, setButtonNameEvents] = useState("Show more");

  useEffect(() => {
    canYouHaveAccess();
  }, []);

  return (
    <>
      <div>
        <BannerOne
          bannerImage={homepageBanner}
          title={TITLE}
          buttonName={BUTTON_NAME}
          buttonLink={BUTTON_LINK}
          targetFirstButton="_parent"
        />
        <Container className="mt-5">
          <Row>
            <Col xs={12} sm={12} md={12} lg={8} className="mb-5">
              <Carousel>
                {ALL_BANNERS.map((b) => (
                  <Carousel.Item>
                    <a href={b.link} target={b.target}>
                      <Image src={b.image} width={b.width} />
                    </a>
                  </Carousel.Item>
                ))}
              </Carousel>
              {/* <div>
                        <Title className={"mt-5"} title={"Role-based training"}/>
                        <div className="frameTraining mt-4">
                            <div className="frameRow" >
                                <CardLink icon={salesIcon} link={"https://partners.dynatrace.com/#/page/sales_enablement"} buttonName="Sales" width="30%"/>
                                <CardLink icon={salesSpecialistIcon} link={"https://partners.dynatrace.com/#/page/sales_specialist"} buttonName="Sales specialist" width="10%"/>
                            </div>
                            <div className="frameRow" >
                                <CardLink icon={salesEngineerIcon} link={"https://partners.dynatrace.com/#/page/sales_engineer"} buttonName="Sales engineer" width="12%"/>
                                <CardLink icon={deliveryConsultantIcon} link={"https://partners.dynatrace.com/#/page/delivery_consultant"} buttonName="Delivery consultant" width="10%"/>
                            </div>
                        </div>
                    </div> */}
              <div>
                <Title className={"mt-5"} title={"Deal management"} />
                <div className="dealCard mt-3">
                  <img className="imgCard" src={deal_banner} width="100%" />
                  <div className="dealContent">
                    <Title
                      className={"ml-4"}
                      withoutLine={true}
                      title={"Partner deal registration"}
                    />
                    <ButtonOne
                      text={"Learn more"}
                      className={"ml-4 pad6"}
                      classNameOfA={"wid57"}
                      link={"https://partners.dynatrace.com/#/page/sales"}
                      withoutIcon={true}
                    />
                  </div>
                </div>
              </div>
              <div>
                <Title className={"mt-5"} title={"Demo"} />
                <div className="cardDemo mt-3">
                  <div className="demoContent">
                    <Title
                      withoutLine={true}
                      classNameText="fontSize18"
                      title={
                        <div>
                          Access our demo<br></br> environment to deliver the
                          <br></br> best presentations to your prospects
                        </div>
                      }
                    />
                    <ButtonOne
                      text={"Learn more"}
                      classNameOfA={"wid45"}
                      className={"pad7"}
                      link={"https://demo.live.dynatrace.com/"}
                      withoutIcon={true}
                    />
                  </div>
                  <img className="demoImgCard" src={demo_banner} width="50%" />
                </div>
              </div>
            </Col>
            {/* SECOND COLUMN */}
            <Col xs={12} sm={12} md={12} lg={4}>
              <div className="frameOne">
                <Title title={"News & announcements"} className="width100" />
                <NewsSection
                  newsList={ALL_NEWS_LIST}
                  buttonName={buttonNameNews}
                  action={ShowMoreOrLessNews}
                />
                <Title
                  title={"Webinars & featured events"}
                  className="width100"
                />
                {/* <NewsSection newsList={ALL_EVENTS_LIST} action={ShowMoreOrLessEvents} /> */}
                <NewsSection
                  newsList={ALL_EVENTS_LIST}
                  buttonName={buttonNameEvents}
                  action={ShowMoreOrLessEvents}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );

  function canYouHaveAccess() {
    try {
      if (
        process.env.REACT_APP_PROTECT_PAGE === "true" &&
        window.top?.location.host !== process.env.REACT_APP_ALLOW_API
      ) {
        console.log("You shall not pass");
        history.push("/not-found");
      }
    } catch (err) {}
  }

  function ShowMoreOrLessEvents() {
    setButtonNameEvents(
      buttonNameEvents === "Show more" ? "Show less" : "Show more"
    );
    ALL_EVENTS_LIST.forEach((e) => (e.show = !e.show));
  }

  function ShowMoreOrLessNews() {
    setButtonNameNews(
      buttonNameNews === "Show more" ? "Show less" : "Show more"
    );
    ALL_NEWS_LIST.forEach((e) => (e.show = !e.show));
  }
}

export default WelcomeOnlyPdr;
